const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBadgeCheck(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6624_231840)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.0606 3.81849C13.5232 3.31087 12.7983 2.99965 12.0008 2.99965C11.2032 2.99965 10.4782 3.31094 9.94088 3.81865C9.40919 4.321 9.14334 4.57218 9.06801 4.61718C8.90675 4.71353 9.0356 4.66013 8.85346 4.7061C8.76838 4.72757 8.4028 4.73806 7.67163 4.75906C6.93299 4.78026 6.2007 5.07274 5.63695 5.63649C5.0731 6.20034 4.78061 6.93279 4.7595 7.67156C4.7386 8.4025 4.72816 8.76797 4.7067 8.85306C4.66076 9.03517 4.71412 8.90638 4.61781 9.06762C4.57281 9.14296 4.32175 9.40875 3.81962 9.94032L3.81961 9.94033C3.31204 10.4777 3.00085 11.2025 3.00085 12C3.00085 12.7975 3.31204 13.5223 3.81961 14.0597C4.32175 14.5913 4.57281 14.857 4.61781 14.9324C4.71412 15.0936 4.66076 14.9648 4.7067 15.1469C4.72816 15.232 4.7386 15.5975 4.7595 16.3284L4.7595 16.3284C4.78061 17.0672 5.0731 17.7997 5.63695 18.3635C6.20069 18.9273 6.93298 19.2197 7.67162 19.2409C8.4028 19.2619 8.76839 19.2724 8.85348 19.2939C9.03562 19.3399 8.90676 19.2865 9.06802 19.3828C9.14335 19.4278 9.4092 19.679 9.94091 20.1814C10.4783 20.6891 11.2032 21.0004 12.0008 21.0004C12.7985 21.0004 13.5235 20.689 14.0609 20.1812L14.061 20.1812C14.5927 19.6788 14.8585 19.4276 14.9338 19.3826C15.0951 19.2862 14.9662 19.3396 15.1484 19.2936C15.2334 19.2722 15.599 19.2616 16.3302 19.2406L16.3303 19.2406C17.0689 19.2193 17.8011 18.9269 18.3648 18.3632C18.9287 17.7993 19.2211 17.0668 19.2422 16.3281C19.2631 15.5971 19.2736 15.2317 19.295 15.1466C19.341 14.9645 19.2876 15.0933 19.3839 14.932C19.4289 14.8567 19.68 14.5909 20.1821 14.0593C20.6897 13.522 21.0008 12.7971 21.0008 11.9997C21.0008 11.2022 20.6897 10.4773 20.1821 9.93999C19.68 9.40841 19.4289 9.14262 19.3839 9.06728C19.2876 8.90604 19.3409 9.03483 19.295 8.85272C19.2735 8.76763 19.2631 8.40216 19.2422 7.67122C19.2211 6.93245 18.9286 6.19999 18.3648 5.63614C17.801 5.07233 17.0686 4.77985 16.3298 4.7587C15.5987 4.73777 15.2331 4.7273 15.148 4.70583C14.9659 4.65988 15.0947 4.71327 14.9335 4.61694C14.8581 4.57194 14.5923 4.32081 14.0606 3.81856L14.0606 3.81849Z",
    stroke: "#319300",
    style: {
      stroke: "#319300",
      stroke: "color(display-p3 0.1922 0.5765 0.0000)",
      strokeOpacity: 1
    },
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.5 12.5L10.0089 14.0089C10.3526 14.3526 10.5245 14.5245 10.7198 14.5822C10.8914 14.6328 11.0749 14.6245 11.2412 14.5585C11.4305 14.4834 11.5861 14.2967 11.8973 13.9232L16 9",
    stroke: "#319300",
    style: {
      stroke: "#319300",
      stroke: "color(display-p3 0.1922 0.5765 0.0000)",
      strokeOpacity: 1
    },
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6624_231840"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadgeCheck);
export default __webpack_public_path__ + "static/media/badge-check.5d4b8e85055e7b2361391188c619f7d3.svg";
export { ForwardRef as ReactComponent };